function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { definePropType } from "@types-vue/props";
import { addProjectDemo, getProjectDemoSourceInfo } from "@/api/demo/project";
import { DemoType } from "@/api/demo/type";
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { debounce } from "lodash-es";
export default defineComponent({
    name: "ProjectDemoAddDialog",
    props: {
        type: {
            type: definePropType(String),
            default: DemoType.PLAYABLE
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var updateSourceInfo = function updateSourceInfo() {
            getProjectDemoSourceInfo({
                id: model.value.src_project_id,
                type: props.type
            }).then(function(res) {
                if (res.data.data) {
                    showResult.value = true;
                    model.value = _objectSpreadProps(_objectSpread({}, res.data.data), {
                        name: res.data.data.src_project_name
                    });
                    isError.value = false;
                } else {
                    // 下面catch会处理
                    throw new Error(" not found");
                }
            }).catch(function() {
                showResult.value = false;
                isError.value = true;
            });
        };
        var reset = function reset() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            showResult.value = false;
            isError.value = false;
        };
        var showAddDialog = function showAddDialog() {
            visible.value = true;
        };
        var submit = function submit() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    handleAdd();
                }
            });
        };
        var cancel = function cancel() {
            visible.value = false;
        };
        var handleAdd = function handleAdd() {
            loading.value = true;
            addProjectDemo(_objectSpread({}, model.value)).then(function() {
                emit("addSuccess");
            }).finally(function() {
                loading.value = false;
                visible.value = false;
            });
        };
        var schemaForm = ref();
        var visible = ref(false);
        var loading = ref(false);
        var showResult = ref(false);
        var isError = ref(false);
        var formConfig = reactive({
            labelWidth: "165px"
        });
        var isFocusing = ref(false);
        var model = ref({
            name: "",
            src_adv_id: 0,
            src_adv_name: "",
            src_project_id: "",
            src_project_name: "",
            src_project_type: "",
            thumb_url: "",
            type: props.type
        });
        var updateSourceInfoDebounce = debounce(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        updateSourceInfo();
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })), 500);
        var schema = computed(function() {
            var resultItems = {};
            if (showResult.value) {
                resultItems = {
                    src_adv_name: {
                        label: "\u5E7F\u544A\u4E3B\u540D\u79F0",
                        component: "plain-text"
                    },
                    src_project_name: {
                        label: "\u9879\u76EE\u540D\u79F0",
                        component: "plain-text"
                    },
                    name: {
                        label: "demo\u540D\u79F0",
                        component: "input",
                        rules: [
                            {
                                required: true,
                                message: "\u8BF7\u8F93\u5165demo\u540D\u79F0",
                                trigger: "blur"
                            }, 
                        ]
                    }
                };
            }
            return {
                type: "object",
                properties: _objectSpread({
                    src_project_id: {
                        label: "\u524D\u53F0\u9879\u76EEid",
                        component: "input",
                        rules: [
                            {
                                required: true,
                                message: "\u8BF7\u8F93\u5165\u524D\u53F0\u9879\u76EEid",
                                trigger: "change"
                            }, 
                        ],
                        field: {
                            type: "number",
                            listeners: {
                                focus: function() {
                                    isFocusing.value = true;
                                },
                                blur: function() {
                                    isFocusing.value = false;
                                },
                                input: function() {
                                    updateSourceInfoDebounce();
                                }
                            }
                        }
                    }
                }, resultItems)
            };
        });
        watch(function() {
            return visible.value;
        }, function(val) {
            if (!val) {
                reset();
            }
        });
        return {
            isFocusing: isFocusing,
            loading: loading,
            schemaForm: schemaForm,
            formConfig: formConfig,
            model: model,
            isError: isError,
            schema: schema,
            visible: visible,
            DemoType: DemoType,
            showAddDialog: showAddDialog,
            submit: submit,
            cancel: cancel
        };
    }
});
